/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetProjectsListMetaRequest,
  TGetProjectsListMetaModel,
  IMappers,
  TGetProjectsListMetaResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetProjectsListMetaResponse } from '../../entities/v1_entities/GetProjectsListMetaResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetProjectsListMetaModel(parameters: IGetProjectsListMetaRequest): TGetProjectsListMetaModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'countryside-constructors',
    pathApi: '/v1/get-projects-list-meta/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetProjectsListMetaOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsListMetaRequest;
}

export async function fetchGetProjectsListMeta<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsListMetaOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetProjectsListMetaResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetProjectsListMetaModel(parameters),
    config,
  )) as FetchResponse<TGetProjectsListMetaResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetProjectsListMetaResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetProjectsListMetaResponse>;
}
